import Navbar from '../../../components/navbar/navbar'
import { Codigos } from './Codigos'
import { TiposOS } from './TiposOS'
import { Container } from './styles'

export function CodigoOperacaoTipoOS() {
  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <Codigos />
        <TiposOS />
      </Container>
    </>
  )
}
